import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarIcon } from '@heroicons/react/24/outline';

const Namuna1 = () => {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState('2025-04-01');
  const [toDate, setToDate] = useState('2026-03-31');

  const handleSubmit = () => {
    console.log('Form submitted:', { fromDate, toDate });
  };

  // Convert date format for display
  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB').replace(/\//g, '/');
  };

  // Handle date change
  const handleFromDateChange = (e) => {
    const date = e.target.value;
    setFromDate(date);
  };

  const handleToDateChange = (e) => {
    const date = e.target.value;
    setToDate(date);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">

          {/* Header */}
          <div className="bg-[#267c77] text-white px-6 py-4 text-center">
            <h1 className="text-2xl font-bold">नमुना १</h1>
          </div>

          {/* Back Button */}
          <div className="px-6 py-4 bg-gray-50 border-b">
            <button
              onClick={() => navigate('/aarthikreport')}
              className="flex items-center gap-2 bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 transition-colors duration-200"
            >
              ← Back
            </button>
          </div>

          {/* Form Content */}
          <div className="p-6">
            <div className="space-y-6">

              {/* From Date Field */}
              <div className="flex items-center space-x-4">
                <label className="text-gray-700 font-medium w-32">
                  दिनांका पासून
                </label>
                <div className="relative flex-1">
                  <input
                    type="date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:border-transparent"
                  />
                </div>
              </div>

              {/* To Date Field */}
              <div className="flex items-center space-x-4">
                <label className="text-gray-700 font-medium w-32">
                  दिनांका पर्यंत
                </label>
                <div className="relative flex-1">
                  <input
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:border-transparent"
                  />
                </div>
              </div>

            </div>

            {/* Submit Button */}
            <div className="mt-8 flex justify-center">
              <button
                onClick={handleSubmit}
                className="bg-[#267c77] text-white px-8 py-3 rounded-md font-medium hover:bg-[#267c77] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:ring-offset-2"
              >
                नमुना १
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Namuna1;